export const DEFAULT_PRIMARY_COLOR = "#493AB1";

export const AUDIO_TIME_CONSTANTS = {
  SECONDS_IN_MINUTE: 60,
  PAD_LENGTH: 2,
  DEFAULT_TIME_STRING: "0:00",
  INITIAL_TIME: 0,
};

export const AUDIO_SLIDER_CONFIG = {
  MIN: 0,
  DEFAULT_MAX: 100,
  STEP: 0.1,
  PERCENTAGE_MAX: 100,
};

export const POST_AUDIO_TEXTS = {
  ARIA_PLAY: "Play",
  ARIA_PAUSE: "Pause",
  ARIA_REMOVE: "Remove audio",
  DEFAULT_TITLE_PREFIX: "Audio clip",
  RECORD_KEYWORD: "record",
  FAILED_TO_PLAY_ERROR: "Failed to play audio:",
};

export const WAVE_BAR_HEIGHTS = [
  25, 45, 65, 50, 80, 95, 70, 55, 100, 85, 50, 75, 90, 60, 40, 70, 85, 100, 90,
  70, 50, 65, 80, 95, 75, 55, 85, 100, 70, 50, 80, 60, 45, 70, 55, 40, 60, 50,
  35, 25, 40, 65, 80, 95, 70, 50, 30,
];
